/**
 * Helper functions for handling external link domains (MakerWorld, Printables, etc.)
 */

/**
 * Map of known 3D printing site domains to their display colors
 */
const DOMAIN_COLOR_MAP: Record<string, string> = {
  'makerworld.com': 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300',
  'printables.com': 'bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-300',
  'thingiverse.com': 'bg-cyan-100 text-cyan-800 dark:bg-cyan-900/30 dark:text-cyan-300',
  'thangs.com': 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
  'cults3d.com': 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
};

/**
 * Map of known 3D printing site domains to their display labels
 */
const DOMAIN_LABEL_MAP: Record<string, string> = {
  'makerworld.com': 'MakerWorld',
  'printables.com': 'Printables',
  'thingiverse.com': 'Thingiverse',
  'thangs.com': 'Thangs',
  'cults3d.com': 'Cults3D',
  'myminifactory.com': 'MyMiniFactory',
};

/**
 * Get badge color classes for a domain
 * @param domain - Domain name (e.g., "makerworld.com")
 * @returns Tailwind CSS classes for badge styling
 */
export function getBadgeColor(domain: string): string {
  return DOMAIN_COLOR_MAP[domain] || 'bg-background-subtle text-foreground-muted';
}

/**
 * Get display label for a domain
 * @param domain - Domain name (e.g., "makerworld.com")
 * @returns Human-readable label (e.g., "MakerWorld") or the domain if unknown
 */
export function getDomainLabel(domain: string): string {
  return DOMAIN_LABEL_MAP[domain] || domain;
}
